<h1 mat-dialog-title>{{ getLabel('titleLabel') }}</h1>

<div mat-dialog-content>

  <p>
    {{ getLabel('textLabel')}}
  </p>

  <form [formGroup]="form" class="form-container">

    <app-select-search *ngIf="checkFieldsToActivate('contactChannel')" class="width100" appearance="fill" formControlName="contactChannel" [items]="options?.contactChannels" viewField="name" [label]="getLabelSelect('contactChannel')">
    </app-select-search>

    <app-select-search *ngIf="checkFieldsToActivate('origin')" class="width100" appearance="fill" formControlName="origin" [items]="options?.origins" viewField="origin" [label]="getLabelSelect('origin')">
    </app-select-search>

    <app-select-search *ngIf="checkFieldsToActivate('marketingNoteId')" class="width100" appearance="fill" formControlName="marketingNoteId" [items]="options?.marketingNotes" viewField="name" [label]="getLabelSelect('marketingNote')">
    </app-select-search>

  </form>

</div>

<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="form.value" [disabled]="disabledConfirmButton()">{{ confirmButtonLabel |
    translate }}</button>
  <button mat-button [mat-dialog-close]="">{{ cancelButtonLabel | translate }}</button>
</div>